var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var _PICWebSocketClient_instances, _PICWebSocketClient_socket, _PICWebSocketClient_eventList, _PICWebSocketClient_intervalId, _PICWebSocketClient_connectSocket;
import { PIC } from '../../templates/Internals';
/**
 * Class for connecting to the PICit WebSocket Server
 * Only reads the first protocol
 */
export class PICWebSocketClient {
    constructor(options) {
        _PICWebSocketClient_instances.add(this);
        _PICWebSocketClient_socket.set(this, void 0);
        _PICWebSocketClient_eventList.set(this, []);
        _PICWebSocketClient_intervalId.set(this, void 0);
        __classPrivateFieldSet(this, _PICWebSocketClient_socket, __classPrivateFieldGet(this, _PICWebSocketClient_instances, "m", _PICWebSocketClient_connectSocket).call(this, options), "f");
        __classPrivateFieldSet(this, _PICWebSocketClient_intervalId, setInterval(() => {
            if (__classPrivateFieldGet(this, _PICWebSocketClient_socket, "f") instanceof WebSocket && this.isClosed) {
                console.log('Attempting to reconnect closed socket', this);
                __classPrivateFieldSet(this, _PICWebSocketClient_socket, __classPrivateFieldGet(this, _PICWebSocketClient_instances, "m", _PICWebSocketClient_connectSocket).call(this, options), "f");
                __classPrivateFieldGet(this, _PICWebSocketClient_socket, "f").addEventListener('open', () => {
                    if (this.isOpen) {
                        __classPrivateFieldGet(this, _PICWebSocketClient_eventList, "f").forEach(evtbl => {
                            if (evtbl)
                                this.addSocketEventListener(evtbl[0], evtbl[1]);
                        });
                    }
                });
            }
            //TODO: implement close from server
            //TODO: implement heartbeat / ping - pong
            if (this.isOpen) {
                __classPrivateFieldGet(this, _PICWebSocketClient_socket, "f").send('');
            }
        }, 30000), "f");
    }
    get isOpen() { return __classPrivateFieldGet(this, _PICWebSocketClient_socket, "f").readyState === WebSocket.OPEN; }
    get isClosed() { return __classPrivateFieldGet(this, _PICWebSocketClient_socket, "f").readyState === WebSocket.CLOSED; }
    get readyState() {
        return __classPrivateFieldGet(this, _PICWebSocketClient_socket, "f").readyState;
    }
    /**
     *
     * @param event EventType
     * @param eventFunction Function to call, takes an event
     * @returns index for calling `removeSocketEventListener`
     */
    addSocketEventListener(event, eventFunction) {
        __classPrivateFieldGet(this, _PICWebSocketClient_socket, "f").addEventListener(event, eventFunction);
        return __classPrivateFieldGet(this, _PICWebSocketClient_eventList, "f").push([event, eventFunction]) - 1;
    }
    removeSocketEventListener(idx) {
        if (idx < 0 || idx > __classPrivateFieldGet(this, _PICWebSocketClient_eventList, "f").length - 1 || __classPrivateFieldGet(this, _PICWebSocketClient_eventList, "f")[idx] === null) {
            return false;
        }
        let [key, event] = __classPrivateFieldGet(this, _PICWebSocketClient_eventList, "f")[idx];
        __classPrivateFieldGet(this, _PICWebSocketClient_socket, "f").removeEventListener(key, event);
        __classPrivateFieldGet(this, _PICWebSocketClient_eventList, "f")[idx] = null;
        //this.eventList.splice(idx, 1) //would mess up indexes .... indices
        return true;
    }
    /**
     * Close socket, and stop reconnect interval
     */
    closeSocket() {
        if (__classPrivateFieldGet(this, _PICWebSocketClient_socket, "f") instanceof WebSocket && __classPrivateFieldGet(this, _PICWebSocketClient_socket, "f").OPEN) {
            clearInterval(__classPrivateFieldGet(this, _PICWebSocketClient_intervalId, "f"));
            __classPrivateFieldGet(this, _PICWebSocketClient_socket, "f").close();
        }
    }
}
_PICWebSocketClient_socket = new WeakMap(), _PICWebSocketClient_eventList = new WeakMap(), _PICWebSocketClient_intervalId = new WeakMap(), _PICWebSocketClient_instances = new WeakSet(), _PICWebSocketClient_connectSocket = function _PICWebSocketClient_connectSocket(options) {
    if (!options.systemId || !options.sessionCode || !options.channelId) {
        let err = {
            message: 'Missing WebSocket options',
            object: options
        };
        throw Error(JSON.stringify(err));
    }
    if (!options.host) {
        if (PIC.systemId.includes('udv') || PIC.systemId.includes('sfltest') || PIC.systemId.includes('gtstest'))
            options.host = 'udv.picit.dk/api/wss';
        else if (PIC.systemId.match(/rnd\d+_test/))
            options.host = `rndapi.picit.dk/${PIC.systemId}/wss`;
        else if (PIC.systemId.includes('_test'))
            options.host = 'demo.picit.dk/wss';
        else
            options.host = `web.picit.dk/${PIC.systemId}/wss`;
    }
    const socket = new WebSocket(`wss://${options.host}${options.port.length > 0 ? `:${options.port}` : ''}`, [options.channelId]);
    socket.addEventListener('open', (event) => {
        socket.send(JSON.stringify({
            package: 'init',
            channelId: options.channelId,
            session: options.sessionCode,
            picsystem: options.systemId
        }));
    });
    /*socket.addEventListener('close', (event: CloseEvent) => {
        //Clear eventListeners
        for (let elm of this.#eventList) {
            if (elm === null) continue
            let [key, event] = elm as [keyof WebSocketEventMap, eventFnc]
            this.#socket.removeEventListener(key, event)
        }
        this.#eventList = []
    })*/
    socket.addEventListener('error', (event) => {
        console.log(event);
    });
    socket.addEventListener('message', (event) => {
        if (event.data === 'REJECT') {
            console.warn('Connection rejected');
            this.closeSocket();
        }
    });
    if (!options.managedByPic) {
        //close socket on SUBMIT 
        //TODO also close if opened in modal
        window.addEventListener('ClosePicSockets', () => {
            this.closeSocket();
        });
    }
    return socket;
};
//# sourceMappingURL=PICWebSocketClient.js.map